import React from 'react'
import { ClickAwayListener, Popper, Fade, Box } from '@mui/material'
import { Comments } from '../../Comments'
import { CommentsProps } from '../../Comments.types'
import { useIsMobileDevice } from '../../../../hooks/useIsMobileDevice'

const POPOVER_MODIFIERS = [
    {
        name: 'offset',
        options: {
            // [skid, distance] — for right-start: skid moves along Y, distance moves away to the right
            offset: [-12, 10],
        },
    },
    {
        name: 'flip',
        enabled: true,
        options: {
            altBoundary: false,
            rootBoundary: 'viewport',
            padding: 8,
        },
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            altAxis: true,
            altBoundary: true,
            tether: false,
            rootBoundary: 'viewport',
            padding: 8,
        },
    },
]

export interface TPPCellCommentsPopoverProps extends CommentsProps {
    anchorEl: HTMLElement | null
    open: boolean
    onClose: () => void
}

export const TPPCellCommentsPopover = ({ anchorEl, open, onClose, ...commentsProps }: TPPCellCommentsPopoverProps) => {
    const isMobileDevice = useIsMobileDevice()

    const handleClose = () => {
        onClose()
    }

    return (
        <Popper
            open={open}
            anchorEl={anchorEl}
            placement={isMobileDevice ? 'bottom' : 'right-start'}
            modifiers={POPOVER_MODIFIERS}
            //strategy="fixed"
            sx={(theme) => ({ zIndex: theme.zIndex.modal - 1 })}
        >
            {({ TransitionProps }) => (
                <ClickAwayListener onClickAway={handleClose} mouseEvent="onMouseDown" touchEvent="onTouchStart">
                    <Fade {...TransitionProps} in={open} timeout={800} unmountOnExit mountOnEnter>
                        <Box
                            sx={{
                                height: 'clamp(20rem, 50vh, 40rem)',
                                width: 'clamp(320px, 25rem, 30rem)',
                            }}
                        >
                            {/* CommentsProps: { dataId, dataType, minimized? } */}
                            <Comments {...commentsProps} minimized />
                        </Box>
                    </Fade>
                </ClickAwayListener>
            )}
        </Popper>
    )
}
